<template>
  <v-container grid-list-md>
    <h1>{{ $store.getters.dictionaryName }} / Alphabet ({{ transliteratedLetters.length }})</h1>

    <TransliteratedLettersList :letters="transliteratedLetters" v-on:change="edit"></TransliteratedLettersList>

    <TransliteratedLetterDialog v-model="dialog" :model="model"></TransliteratedLetterDialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'
import { FETCH_TRANSLITERATED_ALPHABET } from '../store/action-types'
import TransliteratedLettersList from '../components/TransliteratedLettersList'
import TransliteratedLetterDialog from '../components/TransliteratedLetterDialog'

export default {
  components: { TransliteratedLetterDialog, TransliteratedLettersList },
  data () {
    return {
      dialog: false,
      model: null
    }
  },
  computed: {
    ...mapState([
      'dictionary',
      'transliteratedLetters'
    ])
  },
  created () {
    this.debouncedfetchList = debounce(this.fetchList, 100)

    this.debouncedfetchList()
  },
  watch: {
    dictionary () {
      if (this.dictionary) {
        this.debouncedfetchList()
      }
    }
  },
  methods: {
    edit (model) {
      this.model = model
      this.dialog = true
    },
    async fetchList () {
      await this.$store.dispatch(FETCH_TRANSLITERATED_ALPHABET)
    },
    create () {
      this.model = null
      this.dialog = true
    }
  }
}
</script>
